<template>
  <div class="h-100">
    <div
      id="timelineList"
      :style="{
        height: timelineHeight + 'px',
        overflow: 'scroll',
        'overscroll-behavior-y': 'contain'
      }"
    >
      <!-- loader -->
      <div v-if="selectActiveConversationLoading" class="h-100">
        <div class="d-flex justify-content-center align-items-center h-100">
          <b-spinner variant="primary" />
        </div>
      </div>

      <div v-else>
        <div v-if="selectTimelineEvents">
          <div v-if="selectTimelineLoading && !selectAllPreviousEventsLoaded">
            <div class="d-flex justify-content-center align-items-center mt-4">
              <b-spinner small variant="primary" />
            </div>
          </div>
          <!-- list div -->
          <Timeline :conversationId="selectActiveConversationId" />
        </div>

        <div v-else class="d-flex justify-content-center align-items-center h-100">
          <div class="text-center">
            <i class="fas fa-inbox" style="font-size: 32px"></i>
            <div>No messages</div>
          </div>
        </div>
      </div>
    </div>
    <!-- messaging component -->
    <MessageBuilder id="messageBuilder" class="message-builder" />
  </div>
</template>

<script>
import Timeline from '../Components/Timeline'
import MessageBuilder from '../Components/MessageBuilder'
import { MIN_TIMELINE_HEIGHT } from '../paneHeights'
import { layoutHeight } from '../layoutViewport'
import { createNamespacedHelpers } from 'vuex'
import { debounce } from 'lodash-es'

const ConversationModuleV2 = createNamespacedHelpers('conversationV2')
const TimelineModuleV2 = createNamespacedHelpers('timelineV2')

export default {
  name: 'TimelineWrapper',
  components: {
    Timeline,
    MessageBuilder
  },
  props: {
    isSidebar: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    timelineHeight: 0,
    resizeObserver: null,
    debouncedResizeHandler: null
  }),
  mounted() {
    this.debouncedResizeHandler = debounce(this.resizeHandler, 200)
    // Observe only the reply box (#messageBuilder) so the timeline height
    // recomputes when it grows/shrinks. Observing document.body created a
    // feedback loop: setting the height changed body content, which refired
    // the observer, which scrolled to the bottom again — the continuous scroll.
    this.resizeObserver = new ResizeObserver(this.debouncedResizeHandler)
    this.resizeObserver.observe(document.getElementById('messageBuilder'))
    window.addEventListener('resize', this.debouncedResizeHandler)
    $('#timelineList')[0].addEventListener('scroll', this.evaluateScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.evaluateScroll)
    window.removeEventListener('resize', this.debouncedResizeHandler)
    this.resizeObserver.disconnect()
  },
  computed: {
    ...ConversationModuleV2.mapGetters([
      'selectActiveConversationId',
      'selectActiveConversationLoading',
      'selectShowDetailsPane',
      'selectIsMobileView'
    ]),
    ...TimelineModuleV2.mapGetters([
      'selectTimelineEvents',
      'selectTimelineLoading',
      'selectAllPreviousEventsLoaded'
    ])
  },
  methods: {
    ...TimelineModuleV2.mapActions(['fetchTimeline']),
    async evaluateScroll(event) {
      var element = event.target
      if (element.scrollTop <= 300) {
        if (!this.selectTimelineLoading && !this.selectAllPreviousEventsLoaded) {
          const oldScrollHeight = element.scrollHeight
          const bSpinnerHeight = 40
          await this.fetchTimeline()
          if (element.scrollTop === 0) {
            element.scrollTop = element.scrollHeight - oldScrollHeight - bSpinnerHeight
          }
        }
      }
    },
    resizeHandler() {
      this.setTimelineHeight()
    },
    setTimelineHeight() {
      // The viewport height, not the body's: the body's is content-driven, so
      // sizing off it lets the body overflow and pushes the reply form away.
      const windowHeight = layoutHeight()
      const headerHeight = $('#timelineHeader')[0]?.offsetHeight || 0
      const builderHeight = $('#messageBuilder')[0]?.offsetHeight || 0
      // The same floor MessageList adds to the reply box height, so the two fit
      // inside the pane together.
      this.timelineHeight = Math.max(
        MIN_TIMELINE_HEIGHT,
        windowHeight - headerHeight - builderHeight
      )
      const el = document.querySelector('#timelineList')
      if (el) {
        const listHeight = el.getBoundingClientRect().height
        const diff = el.scrollHeight - el.scrollTop
        if (diff <= listHeight) {
          setTimeout(() => {
            el.scrollTop = el.scrollHeight
          }, 1)
        }
      }
    }
  }
}
</script>
